import { FORMS_WIDGET_TYPE } from '../../constants/reentry-planning.constants';

/** Sets `formIds` on one Forms widget across sections without mutating section state. */
export const replaceFormsWidgetFormIds = (sections = [], widgetId, formIds) =>
  sections.map((section) => ({
    ...section,
    widgets: (section.widgets ?? []).map((widget) =>
      widget.id === widgetId && widget.type === FORMS_WIDGET_TYPE
        ? { ...widget, props: { ...widget.props, formIds } }
        : widget,
    ),
  }));
